import { Wrapper, InnerWrapper, Logo } from './styles';
import logo from '../../resources/logo_higher_resolution.png';
import { ClipLoader } from 'react-spinners';
import { primaryColor } from '../../config/colors';

const LoadingScreen = () => {
  return (
    <Wrapper>
      <InnerWrapper>
        <Logo src={logo} />
        <ClipLoader
          loading={true}
          size={100}
          color={primaryColor}
        />
      </InnerWrapper>
    </Wrapper>
  );
};

export default LoadingScreen;
